// CategorySubcategoryList.js

import React, { useState } from "react";

import {
  Card,
  Table,
  Badge,
  Dropdown,
  Form,
  Collapse,
} from "react-bootstrap";

import {
  FiFolder,
  FiLayers,
  FiMoreVertical,
  FiEdit2,
  FiTrash2,
  FiSearch,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/fi";

import styles from "./CategorySubcategoryList.module.css";

const dummyData = [
  {
    _id: "1",

    name: "Electronics",

    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c",

    isActive: true,

    subCategories: [
      {
        _id: "11",
        name: "Mobiles",
        isActive: true,
      },

      {
        _id: "12",
        name: "Laptops",
        isActive: true,
      },

      {
        _id: "13",
        name: "Accessories",
        isActive: false,
      },

      {
        _id: "14",
        name: "Camera",
        isActive: true,
      },

      {
        _id: "15",
        name: "TV",
        isActive: true,
      },
    ],
  },

  {
    _id: "2",

    name: "Fashion",

    image:
      "https://images.unsplash.com/photo-1445205170230-053b83016050",

    isActive: true,

    subCategories: [
      {
        _id: "21",
        name: "Men",
        isActive: true,
      },

      {
        _id: "22",
        name: "Women",
        isActive: true,
      },
    ],
  },
];

const CategorySubcategoryList = ({
  data = dummyData,
  onCategoryEdit,

  onCategoryDelete,

  onSubCategoryEdit,

  onSubCategoryDelete,
}) => {
  const [search, setSearch] = useState("");

  const [openRows, setOpenRows] =
    useState([]);

  // ================= SEARCH =================

  const filteredData = data.filter((item) =>
    item?.name
      ?.toLowerCase()
      ?.includes(search.toLowerCase())
  );

  // ================= TOGGLE =================

  const toggleRow = (id) => {
    setOpenRows((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  return (
    <Card className={styles.mainCard}>
      <Card.Body className={styles.cardBody}>
        

        {/* ================= TABLE ================= */}

        <div className={styles.tableWrapper}>
          <Table borderless className="mb-0">
            <thead>
              <tr>
                <th
                  className={styles.stickyColumn}
                >
                  Category
                </th>

                <th>Status</th>

                <th align="right">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredData?.map((item) => {
                const isOpen =
                  openRows.includes(item._id);

                return (
                  <React.Fragment
                    key={item._id}
                  >
                    {/* ================= CATEGORY ROW ================= */}

                    <tr
                      className={
                        styles.categoryRow
                      }
                      onClick={() =>
                        toggleRow(item._id)
                      }
                    >
                      {/* CATEGORY */}

                      <td
                        className={
                          styles.stickyColumn
                        }
                      >
                        <div
                          className={
                            styles.categoryInfo
                          }
                        >
                          {/* IMAGE */}

                          <img
                            src={item?.image}
                            alt={item?.name}
                            className={
                              styles.categoryImage
                            }
                          />

                          {/* CONTENT */}

                          <div
                            className={
                              styles.categoryContent
                            }
                          >
                            <div
                              className={
                                styles.categoryName
                              }
                            >
                              <FiFolder />

                              {item?.name}
                            </div>

                            <div
                              className={
                                styles.categoryMeta
                              }
                            >
                              {
                                item
                                  ?.subCategories
                                  ?.length
                              }{" "}
                              Sub Categories
                            </div>
                          </div>

                          {/* TOGGLE */}

                          <div
                            className={
                              styles.expandIcon
                            }
                          >
                            {isOpen ? (
                              <FiChevronUp />
                            ) : (
                              <FiChevronDown />
                            )}
                          </div>
                        </div>
                      </td>

                      {/* STATUS */}

                      <td>
                        <Badge
                          bg={
                            item?.isActive
                              ? "success"
                              : "secondary"
                          }
                          className={
                            styles.statusBadge
                          }
                        >
                          {item?.isActive
                            ? "Active"
                            : "Inactive"}
                        </Badge>
                      </td>

                      {/* ACTION */}

                      <td
                        align="right"
                        onClick={(e) =>
                          e.stopPropagation()
                        }
                      >
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            className={
                              styles.menuBtn
                            }
                          >
                            <FiMoreVertical />
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            className={
                              styles.dropdownMenu
                            }
                          >
                            <Dropdown.Item
                              onClick={() =>
                                onCategoryEdit?.(
                                  item
                                )
                              }
                            >
                              <FiEdit2 />
                              Edit
                            </Dropdown.Item>

                            <Dropdown.Item
                              className="text-danger"
                              onClick={() =>
                                onCategoryDelete?.(
                                  item
                                )
                              }
                            >
                              <FiTrash2 />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>

                    {/* ================= CHILD ROW ================= */}

                    <tr>
                      <td
                        colSpan={3}
                        className="p-0 border-0"
                      >
                        <Collapse in={isOpen}>
                          <div
                            className={
                              styles.childWrapper
                            }
                          >
                            {item?.subCategories?.map(
                              (sub) => (
                                <div
                                  key={sub?._id}
                                  className={
                                    styles.childItem
                                  }
                                >
                                  {/* LEFT */}

                                  <div
                                    className={
                                      styles.childLeft
                                    }
                                  >
                                    <div
                                      className={
                                        styles.subIcon
                                      }
                                    >
                                      <FiLayers />
                                    </div>

                                    <div>
                                      <div
                                        className={
                                          styles.subName
                                        }
                                      >
                                        {
                                          sub?.name
                                        }
                                      </div>

                                      <div
                                        className={
                                          styles.subId
                                        }
                                      >
                                        ID :
                                        {
                                          sub?._id
                                        }
                                      </div>
                                    </div>
                                  </div>

                                  {/* RIGHT */}

                                  <div
                                    className={
                                      styles.childRight
                                    }
                                  >
                                    <Badge
                                      bg={
                                        sub?.isActive
                                          ? "success"
                                          : "secondary"
                                      }
                                      className={
                                        styles.statusBadge
                                      }
                                    >
                                      {sub?.isActive
                                        ? "Active"
                                        : "Inactive"}
                                    </Badge>

                                    <Dropdown align="end">
                                      <Dropdown.Toggle
                                        className={
                                          styles.menuBtn
                                        }
                                      >
                                        <FiMoreVertical />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu
                                        className={
                                          styles.dropdownMenu
                                        }
                                      >
                                        <Dropdown.Item
                                          onClick={() =>
                                            onSubCategoryEdit?.(
                                              sub,
                                              item
                                            )
                                          }
                                        >
                                          <FiEdit2 />
                                          Edit
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                          className="text-danger"
                                          onClick={() =>
                                            onSubCategoryDelete?.(
                                              sub,
                                              item
                                            )
                                          }
                                        >
                                          <FiTrash2 />
                                          Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </Collapse>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CategorySubcategoryList;